import { useCallback } from 'react';
import * as track from 'lib/gaTracking/crossPageEvents';
import { contactUsModalProps } from '../../ExpiredCardModal';
import useGlobalModal from 'hooks/useGlobalModal';

const useExpiredCardModal = () => {
  const { showModal } = useGlobalModal();

  return useCallback(() => {
    track.expiredCreditCardModalOpened();

    showModal({
      ...contactUsModalProps,
      onClose: ({ actionButtonClicked }) => {
        track.expiredCreditCardModalClosed(actionButtonClicked);
      },
    });
  }, [showModal]);
};

export default useExpiredCardModal;
